import React, { useEffect } from "react";
import WelcomeJourneyFooter from "../WelcomeJourneyFooter";
import { useDispatch, useSelector } from "react-redux";
import { WelcomeJourneyState } from "@/redux/actions/pwaAction";
import { openAccountSidebar } from "@/redux/actions/loggedInUser";
import styles from "./CharityPillar.module.scss";
import Srcset from "@/components/common/Srcset";

const CharityPillar = () => {
  const dispatch = useDispatch();
  const welcomeJourneyStates = useSelector((state) => state.pwa.welcome_journey);
  const handleClick = (e) => {
    e.preventDefault();
    //OS-4132 - To fix carousel view hide-hero-carousal class is added
    // document.querySelector("main").classList.add("hide-hero-carousal");
    document.querySelector("#__next").classList.add("pwa-transition");
    setTimeout(() => {
      document.querySelector("#__next").classList.remove("pwa-transition");
      // document.querySelector("main").classList.remove("hide-hero-carousal");
    }, 2000);
    dispatch(WelcomeJourneyState({ ...welcomeJourneyStates, addWCOverlay: false, currentStepNo:6, isSkipped:true }));
  };
  const handleLoginClick = (e) => {
    //added transition to account drawer
    // document.querySelector("body").classList.add("pwa-transition");
    dispatch(openAccountSidebar(true))
    // setTimeout(() => {
    //   document.querySelector("body").classList.remove("pwa-transition");
    // }, 2000);
    dispatch(WelcomeJourneyState({ ...welcomeJourneyStates, addWCOverlay: false,currentStepNo:3 }));
  }

  const charityDetails = [
    {
      title:"Education",
      text:"Building futures, breaking barriers",
      image:"https://cdn.shopify.com/s/files/1/0555/6165/0255/files/Education.png?v=1713448029"
    },
    {
      title:"Nature",
      text:"Protecting our planet, securing our future",
      image:"https://cdn.shopify.com/s/files/1/0555/6165/0255/files/Climate.png?v=1713447967"
    },
    {
      title:"Health & Wellness",
      text:"Fostering well-being, igniting change",
      image:"https://cdn.shopify.com/s/files/1/0555/6165/0255/files/Health.png?v=1713448027"
    },
  ]

  return (
    <>
      <div className={`${styles.charity_pillar}`}>
        <h3 className={`heading ${styles.heading}`}>Gender Equality</h3>
        {
          charityDetails.map((ele => {
            return (
              <div className={`${styles.charity_pillar_section}`}>
                <div className={`${styles.charity_pillar_text}`}>
                  <div className="small-xs">{ele.title}</div>
                  <div className={`x-small-xs ${styles.text}`}>{ele.text}</div>
                </div>
                <Srcset src={ele.image} alt={ele.title} />
              </div>
            )
          }))
        }
      </div>
          
      <WelcomeJourneyFooter
        heading="Choose your charity"
        description="Log in / register to choose which charity gets 20% of the net proceeds from your purchase."
        btn1ClickHandler={handleLoginClick}
        btn2ClickHandler={handleClick}
        btn1_text="Log in / register"
        btn2_text="Skip / Start shopping"
        ga4tag1="App: Welcome > Imapct > Log in / register"
        ga4tag2="App: Welcome > Impact > Skip and start shopping"
      />
    </>
  );
};

export default CharityPillar;
